import * as React from 'react'

import { ReactComponent, Subtract } from '../../types'

export interface InjectedValueProps {
  handleChange: (value: any) => void
  resetValue: () => void
  value?: any
}

interface State {
  value?: any
}

function withValue<BaseProps extends InjectedValueProps> (Component: ReactComponent<BaseProps>) {
  type Props = Subtract<BaseProps, InjectedValueProps>

  return class extends React.Component<Props, State> {
    public state = { value: '' }

    public render () {
      return (
        <Component
          handleChange={this.handleChange}
          resetValue={this.resetValue}
          {...this.state}
          {...this.props}
        />
      )
    }

    private handleChange = thing => {
      let value
      if (thing.target) {
        value = thing.target.value
      } else {
        value = thing
      }

      this.setState(({ value }))
    }

    private resetValue = () => {
      this.setState(({ value: '' }))
    }
  }
}

export default withValue



// WEBPACK FOOTER //
// ./src/components/hocs/withValue.tsx